import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { useAppStore } from "@/ts/stores/app";
import { useViewportUtilities } from "@/ts/utils/viewport-utilities";
import { useAnchorEvents } from "@/ts/utils/anchor-events";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

useViewportUtilities();
useAnchorEvents();

const appStore = useAppStore();

onMounted(() => {
    appStore.getGeneralOptions();
    appStore.indexPages();
});

const __returned__ = { appStore, onMounted, useAppStore, useViewportUtilities, useAnchorEvents }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})